import { itemName } from '../../trace/ports.js';
import { defineRule } from '../rule.js';
import { unplacedItems } from '../../model/hierarchy.js';

/** H: an item lies in the unplaced tray (not on the plot, OIL-88: rows of placed lists are). */
export const itemUnplaced = defineRule(
  'item-unplaced',
  'hint',
  { en: 'Item not placed', de: 'Objekt nicht platziert' },
  (data, emit) => unplacedItems(data).map((item) => emit([item.id], { label: itemName(item) })),
);
